module.exports = __webpack_public_path__ + "static/media/image_rural.c8d8d12c.png";